import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { APP_CONTROLLER_REDUCERS } from '@bit/gerenciatd.unifiedcomponents.app-controller';
import ClientCCLIReducer from '@bit/gerenciatd.telcovid.redux-saga-client-c-c-l-i';
import ProductsCCLIReducer from '@bit/gerenciatd.telcovid.redux-saga-products-c-c-l-i';
import solucionesReducer from './soluciones';
import fichasReducer from './fichas';
import commonReducer from './common';


const rootReducers = history => combineReducers({
  router: connectRouter(history),
  soluciones: solucionesReducer,
  fichas: fichasReducer,
  common: commonReducer,
  client: ClientCCLIReducer,
  products: ProductsCCLIReducer,
  context: APP_CONTROLLER_REDUCERS.context,
  errorCatcher: APP_CONTROLLER_REDUCERS.errorCatcher,
});


export default rootReducers;
